export default "__VITE_ASSET__DdO$1FlH__"